import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { UtilsService } from '../services/utils.service';
import { Router } from '@angular/router';
import { AuthService } from '@ascschool/core/auth/auth.service';
import { AuthQuery, AuthStore } from '@ascschool/core/auth';
import { DeviceDetectorService } from 'ngx-device-detector';
@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  currentUser: any;
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);


  constructor(private authenticationService: AuthService,
    private utilsService: UtilsService,
    private router: Router,
    private authStore: AuthStore,
    private deviceService: DeviceDetectorService
  ) {

  }
  token: any;
  device: any;
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.currentUser = this.authenticationService.getUserInfo();
    if (!request.url.includes('Refresh')) {
      // add authorization header with jwt token if available
      if (this.currentUser && this.currentUser.token) {
        request = this.addToken(request, this.currentUser.token);
      }
    }
    return next.handle(request).pipe(
      catchError(error => {
        if (error instanceof HttpErrorResponse || error.status === 401) {
          if (this.currentUser && this.currentUser.accessTokenExpiration) {
            const accessTokenExpiration = new Date(this.currentUser.accessTokenExpiration);
            const now = new Date();
            if (now.getTime() > accessTokenExpiration.getTime()) {
              return this.handle401Error(request, next);
            }
          }
        }
        return throwError(error);
      })
    );
  }
  private addToken(request: HttpRequest<any>, token: string) {
    this.device = this.deviceService.getDeviceInfo();
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
        Browser: this.device.browser,
        Device: this.device.device,
        DeviceType: this.device.deviceType,
        Os: this.device.os,
      }
    });
  }
  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);
      return this.authenticationService.refreshToken({
        accessToken: this.currentUser.token,
        refreshToken: this.currentUser.refreshToken
      }).pipe(
        switchMap((token: any) => {
          if (token.accessToken == null) {
            this.authenticationService.logout();
            this.router.navigate(['/exception/timeout']);
          } else {
            this.isRefreshing = false;
            this.currentUser.token = token.accessToken;
            this.currentUser.accessTokenExpiration = token.accessTokenExpiration;
            this.currentUser.refreshToken = token.refreshToken;
            this.authStore.login(this.currentUser);
            this.refreshTokenSubject.next(token.accessToken);
            return next.handle(this.addToken(request, token.accessToken));
          }
        })
      );
    } else {
      this.authenticationService.logout();
      this.router.navigate(['/exception/401']);
    }
  }
}
